import { Navigate, useLocation, useParams } from "react-router-dom";
import { petViewUrl, PET_VIEW_TAB_PARAM } from "../../enums/UrlPaths";

// Redirects the old /pets/pet/:id/:ownerId links to /pets/pet/:id?user=:ownerId
export default function LegacyPetRedirect() {
  const { id, ownerId } = useParams();
  const { search } = useLocation();
  const tab = new URLSearchParams(search).get(PET_VIEW_TAB_PARAM);
  return <Navigate replace to={petViewUrl(id, ownerId, tab)} />;
}
